import { getCookie } from '../api/lendingApi/lendingApiQueries';
import { ISOLATED_SPLIT_TESTS } from '../constants';

export function useIsInDEOpenBankingCopyTest() {
  const cookieBranch = getCookie(
    `split_test_${ISOLATED_SPLIT_TESTS.DE_OPEN_BANKING_COPY_TEST}`,
  );

  return {
    isIncludedInOBCopyTest: cookieBranch === 'INCLUDE',
  };
}
